import { CommonButton } from 'components/Buttons';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'state/actions';
import selectors from 'state/selectors';
import utils from 'utils';
import { actionType, modalActionType } from 'utils/constants';
import useCheckBeforeAction from '../hooks';

const SendMail = () => {
  const records = useSelector(selectors.documents.selectAllActiveDocuments);
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();
  const saveDocument = utils.hooks.useSaveDocument();
  const { checkDocuments } = useCheckBeforeAction(actionType.SENDMAIL);

  const onClick = async () => {
    const docFree = await checkDocuments();
    if (!docFree) return;
    if ((await saveDocument()) === null) {
      return;
    }
    dispatch(actions.modal.openModal(modalActionType.documents.SEND_MAIL));
  };
  return (
    <CommonButton
      id="send-mail-btn"
      action={onClick}
      disabled={!utils.user.isActionEnabled(records, actionType.SENDMAIL)}
      scope="tertiary"
      value={t('send-mail')}
      customIcon="envelope"
    />
  );
};

export default SendMail;
